// 清分绑卡流程统一校验
import { Modal, message } from 'hljd'
import {
  modalData,
  UN_BOND,
  SMALLL_AUTH,
  UNDER_REVIEW,
  FAIL_REVIEW,
  SUCCESS_BIND
} from '@constant'
import systemApi from '@api/system'
import walletApi from '@api/a_mao/merchantWallet'
import { getMerchantInfo } from '@util'

// 绑卡前置校验
export const preCheck = async () => {
  // 此处不直接取用 getMerchantInfo 中的值，需取用最新的状态
  const {
    data: {
      certify: { status, card_certify_status }
    }
  } = await systemApi.edit()
  if (status === 1) {
    // 1+1审核状态
    return Modal.info(modalData['MerchantReview'])
  } else if (status !== 3 || card_certify_status !== 3) {
    // 未完成实名认证状态,确认后即点击跳转相应页面
    return Modal.info(modalData['Verified'])
  } else {
    return true
  }
}

// 绑卡页面流程校验
export const bindProcess = async (type, fn, link) => {
  if (type === UN_BOND) {
    // 未绑定状态
    showModal('info', {
      ...modalData['UnBind'],
      onOk: () => {
        fn()
      }
    })
  }
  // 已绑定状态(已绑定状态未操作解绑流程)
  else if (type === SUCCESS_BIND) {
    // 解绑之前先确认是否有未完成的提现
    const {
      data: { withdrawMoney }
    } = await walletApi.walletBalance()
    if (withdrawMoney > 0) {
      showModal('warning', modalData['Untie'])
    } else {
      showModal('confirm', {
        ...modalData['isUntie'],
        onOk: () => {
          fn()
        }
      })
    }
  } else {
    // 小额鉴权，审核中，审核失败
    window.location.hash = link
  }
}

export const withdrawProcess = async (type, fn1, fn2) => {
  if (type === UN_BOND) {
    showModal('info', {
      ...modalData['UnBind'],
      onOk: () => fn1()
    })
  }
  // 小额绑卡
  else if (type === SMALLL_AUTH) {
    showModal('warning', modalData['SmallAuth'])
  }
  // 审核中
  else if (type === UNDER_REVIEW) {
    showModal('warning', modalData['UnderReview'])
  }
  // 审核失败
  else if (type === FAIL_REVIEW) {
    showModal('warning', modalData['FailReview'])
  } else {
    // 已绑卡状态确认商家是否可提现
    const { success, msg } = await walletApi.withdrawalCheck()
    if (success) {
      fn2()
    } else {
      Modal.error({
        title: '无法提现',
        content: msg
      })
    }
  }
}
// 解绑方法调用
export const unbindBankCard = async fn => {
  const { success, msg } = await walletApi.unbindBankCard()
  if (success) {
    // 解绑成功调用的方法
    fn()
    showModal('success', {
      ...modalData['untieSuccess'],
      onOk: () => {
        gotoEdit()
      }
    })
  } else {
    message.warning(msg)
  }
}

// 判断是否是企业账户还是个人账户方法
export const isCompony = () => {
  const {
    kind,
    certify: { type }
  } = getMerchantInfo()

  return (kind ? kind : type ? type : '') == 2
}
// 跳转绑卡页面方法
export const gotoEdit = () => {
  window.location.href = isCompony()
    ? '#/localMerchant/settlementAccount/componyChoose'
    : '#/localMerchant/settlementAccount/editAccount'
}
// 获取页面绑卡状态
export const getBindStatus = async () => {
  const { data } = await walletApi.getApproveData()
  const { auditStatus, cardStatus, accountType, certType, auditRemark } = data
  const reviewType = statusFormat(
    auditStatus,
    cardStatus,
    accountType,
    certType
  )
  return { data, reviewType, auditRemark }
}

/**
 * @description: 处理审核流程相关数据，数据状态比较麻烦，转换成页面需要的状态
 * @param {*} auditStatus 审核状态:1待审核，2认证失败，3成功
 * @param {*} cardStatus 绑卡状态：0-新建 1-待验证 2-启用中 3-已解绑 4-解绑失败 5-鉴权失败
 * @param {*} accountType 是否是企业
 * @param {*} certType 绑卡类型
 * @return {*} reviewType：页面用于判断的类型：0:未填写 1.小额鉴权 2.审核中 3.审核失败 4.已绑定
 */
export const statusFormat = (
  auditStatus,
  cardStatus,
  accountType,
  certType
) => {
  let reviewType = 0
  if (auditStatus == 1) {
    reviewType = 2
  } else if (auditStatus == 2) {
    reviewType = 3
  } else {
    if (cardStatus == 2) {
      reviewType = 4
    } else {
      if (certType == 1 && accountType == 2) {
        // 企业小额鉴权状态
        reviewType = 1
      }
    }
  }
  return reviewType
}

export const showModal = (type, res) => {
  return Modal[type](res)
}
